module.exports = __webpack_public_path__ + "img/xds.7dbb5641.png";